import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { CoverageProcessController } from 'src/controllers/coverage-process.controller'
import { CoverageProcessDto } from 'src/dto/coverage-process.dto'

const coverageProcessController = new CoverageProcessController()

export function useGetCoverageProcessList() {
  const { userFarm: farmId } = useAuth()

  return useQuery<CoverageProcessDto[], Error>({
    queryKey: ['getCoverageProcessList', farmId],
    queryFn: () => coverageProcessController.getCoverageProcessList(farmId!),
    enabled: !!farmId
  })
}
